import { createContext, useContext } from 'react';

/**
 * «Questo sottoalbero appartiene a una partita alla cieca CHE SI STA GIOCANDO.»
 *
 * Il valore lo mette `GameScreen`, ed è lo stesso `blindGame` che benda la damiera:
 * `ruleMode === 'blind' && !isGameOver && !readOnly`. Quindi chi guarda da fuori non lo
 * riceve mai, e a partita finita si spegne da solo — la revisione torna disponibile
 * proprio quando serve, cioè per rivedere quel che si è giocato a memoria.
 *
 * Attenzione a leggerlo per quello che è: dice «si sta giocando bendati», NON «la
 * modalità è blind». Le due cose divergono a partita finita, ed è di proposito.
 *
 * UN CONTESTO E NON LO STORE. `spectator-store` riversa la board osservata nello store
 * di gioco con `syncFromExternal`, che ci scrive dentro anche `ruleMode`: chi guarda una
 * partita alla cieca ha quindi `ruleMode === 'blind'` nello store globale pur non
 * essendo bendato per niente. Un `useGameStore((s) => s.ruleMode === 'blind')` gli
 * spegnerebbe la lista mosse sotto il naso. Il `!readOnly` che lo tiene fuori vive solo
 * dentro `blindGame`, e da lì deve arrivare.
 *
 * E NON UNA PROP. La colonna laterale e i pannelli mobili li costruiscono cinque
 * contenitori diversi (`OnlineGame`, `ArenaGame`, `TournamentGame`, `LocalGame`,
 * `SpectateGame`), che dovrebbero ricalcolare la stessa condizione ognuno per conto
 * proprio — cinque occasioni di divergere. Vengono però tutti MONTATI dentro l'albero di
 * `GameScreen` (anche il pannello a schermo intero, che è un portale: i portali
 * conservano la posizione nell'albero React), quindi il contesto li raggiunge tutti.
 *
 * Default `false`: fuori da `GameScreen` — la scacchiera d'analisi dell'editor, e ogni
 * test che monta i componenti da soli — tutto si comporta esattamente come sempre.
 */
export const BlindGameContext = createContext<boolean>(false);

export function useBlindGame(): boolean {
  return useContext(BlindGameContext);
}
